import {Application} from "stimulus";
import Carousel from './swiper_controller';

const application = Application.start()
application.register('swiper', Carousel);